<template>
  <div>
    <div class="modal-backdrop fade show"></div>
    <div class="modal payment-modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <strong class="modal-title">Update Payment Method</strong>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="$emit('close')"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ui-loader v-if="inLoading" />
            <account-payment-form @success="successPayment" />
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-secondary" @click="$emit('close')">
              Close
            </button>
            <button class="btn btn-sm btn-primary" @click="tryUpdate">
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '../../../api'
import UiComponentLoader from '../ui-kit/ui-component-loader.vue'
import UiLoader from '../ui-kit/ui-loader.vue'
export default {
  components: {
    AccountPaymentForm: () => ({
      component: import('./account-payment-form.vue'),
      loading: UiComponentLoader
    }),
    UiLoader
  },
  name: 'account-payment-modal',
  data() {
    return {
      inLoading: false,
      paymentPayload: null
    }
  },
  methods: {
    async successPayment(payload) {
      this.inLoading = true
      console.log('successPayment', payload)
      try {
        await API.account.paymentMethodUpdate(payload)
        await this.$store.dispatch('fetchAccount')
        this.$emit('close')
      } catch (err) {
        console.error(err)
        this.paymentPayload = payload
      } finally {
        this.inLoading = false
      }
    },
    tryUpdate() {
      if (this.paymentPayload) {
        this.successPayment(this.paymentPayload)
      } else {
        // This edge case in vue
        // in <account-payment-form>
        // this.$parent.$on('check-payment')
        this.$emit('check-payment')
      }
    }
  }
}
</script>

<style lang="scss">
.payment-modal {
  display: flex;
  .modal-dialog {
    width: 600px;
    max-width: 100%;
    margin: auto;
  }
}
</style>
